export default "__VITE_ASSET__WuL1pKdn__"